module.exports = __webpack_public_path__ + "img/info-clover-3.b48d3397.svg";